module.exports = __webpack_public_path__ + "static/media/W75F4100-WEB5.e77d08bd.svg";